import '.ah{flex-shrink:0;}.ssr-plugin'
import '.ad{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.aw{height:100%;}.ssr-plugin'
import '.at{border:none;}.ssr-plugin'
import '.cm{background-color:transparent;}.ssr-plugin'
import '.cn{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.br{position:sticky;}.ssr-plugin'
import '.co{top:4rem;}.ssr-plugin'
import '.cp{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.cq{padding-bottom:1rem;}.ssr-plugin'
import '.cr{margin-bottom:1rem;}.ssr-plugin'
import '.cs{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.bc{top:0px;}.ssr-plugin'
import '.bd{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.bf{bottom:0px;}.ssr-plugin'
import '.ct{z-index:9999;}.ssr-plugin'
import '.cu{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bv{justify-content:flex-end;}.ssr-plugin'
import '.ax{flex:1;}.ssr-plugin'
import '.bp{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ah ad l aw at cm cn"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="br co cp t cq cr cs a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="f bc bd be bf ct t cu a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ad a bv cs"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ax bp">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
